import { type TemplateResult } from 'lit';
import { closeIcon } from '../assets/icons';

export const createActionItem = (iconName: TemplateResult, text: string) => {
    const item = document.createElement('vaadin-context-menu-item');
    const wrapper = document.createElement('div');
    const icon = document.createElement('tm-icon');

    icon.style.marginRight = '5px';
    icon.icon = iconName;
    wrapper.classList.add('flex', 'items-center');
    wrapper.appendChild(icon);
    item.appendChild(wrapper);
    if (text) {
        wrapper.appendChild(document.createTextNode(text));
    }
    return item;
};

export const createHeader = (
    title: string,
    icon: TemplateResult = closeIcon,
    eventName: string
) => {
    const header = document.createElement('div');
    const titleEl = document.createElement('span');
    const closeEl = document.createElement('tm-icon');
    closeEl.icon = icon;
    closeEl.color = '#70757A';
    closeEl.addEventListener('click', () => {
        closeEl.dispatchEvent(
            new CustomEvent(eventName, {
                bubbles: true,
                composed: true,
            })
        );
    });
    titleEl.innerHTML = title;
    header.classList.add(
        'text-secondary',
        'text-lg',
        'pb-3',
        'flex',
        'items-center',
        'justify-between'
    );
    header.appendChild(titleEl);
    header.appendChild(closeEl);
    return header;
};
